/** Daftar radio pemilihan template cetak — komponen BERSAMA dipakai oleh semua
 *  modal cetak (Sales.jsx, InputNota.jsx, Retur.jsx, InventoryPO.jsx,
 *  InventoryStok.jsx, OpnameBlind.jsx) saat jenis dokumen yang dipilih punya
 *  LEBIH DARI SATU template untuk dicetak.
 *
 *  Alur lengkapnya (0 template → panel "belum ada template", tepat 1 →
 *  langsung dipakai tanpa menampilkan pilihan ini, >1 → tampilkan pilihan ini
 *  dengan default template sudah terpilih) hidup di masing-masing halaman
 *  (fungsi `bukaCetak*`/`muatDokumenCetak*`) karena tiap halaman punya sumber
 *  data dan endpoint sendiri — komponen ini murni tampilan daftar radio untuk
 *  kasus >1, supaya perbaikan tampilan/aksesibilitas cukup dikerjakan SATU
 *  kali untuk semua halaman.
 *
 *  `testidPrefix` menjaga kontrak data-testid yang sudah dipakai QA di
 *  tiap halaman (awalannya sengaja beda per halaman):
 *    Sales.jsx / InputNota.jsx -> "cetak-tpl"
 *    InventoryPO.jsx           -> "po-cetak-tpl"
 *    InventoryStok.jsx         -> "transfer-cetak-tpl"
 *    Retur.jsx                 -> "rt-cetak-tpl"
 *    OpnameBlind.jsx           -> "ob-cetak-tpl"
 *  Nama grup radio diturunkan dari prefix yang sama (mis. "cetak-tpl" ->
 *  "cetak-pilih-template") supaya beberapa modal cetak berbeda halaman yang
 *  kebetulan terbuka bareng (harusnya tidak terjadi, tapi jaga-jaga) tidak
 *  saling berebut nama grup radio yang sama.
 */
export default function PemilihTemplate({ templates, value, onChange, jenisLabel, testidPrefix }) {
  const radioName = `${testidPrefix.replace(/-tpl$/, "")}-pilih-template`;
  return (
    <div className="space-y-2" data-testid={`${testidPrefix}-list`}>
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">
        Pilih template {jenisLabel} ({templates.length} tersedia)
      </p>
      <div className="space-y-1.5 max-h-72 overflow-y-auto">
        {templates.map((t) => (
          <label key={t.id} data-testid={`${testidPrefix}-opsi-${t.id}`}
            className={`flex items-center gap-2 border rounded-lg px-3 py-2 text-sm cursor-pointer ${
              value === t.id ? "border-emerald-400 bg-emerald-50" : "border-slate-200 hover:bg-slate-50"}`}>
            <input type="radio" name={radioName} checked={value === t.id}
              onChange={() => onChange(t.id)} data-testid={`${testidPrefix}-${t.id}`} className="w-4 h-4 shrink-0" />
            <span className="min-w-0 flex-1">
              <span className="block font-medium text-slate-900 truncate">{t.nama}</span>
              <span className="block text-[11px] text-slate-500">
                {t.ukuran_kertas}{t.cabang ? ` · cabang ${t.cabang}` : " · semua cabang"}
                {t.is_default ? " · Default" : ""}
              </span>
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
